import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  passports: [],
  currentPassport: null,
  participants: [],
  isLoading: false,
  error: null,
  total: 0,
};

export const passportSlice = createSlice({
  name: 'passport',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setPassports: (state, action) => {
      state.passports = action.payload.data;
      state.total = action.payload.total;
      state.isLoading = false;
      state.error = null;
    },
    setCurrentPassport: (state, action) => {
      state.currentPassport = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setParticipants: (state, action) => {
      state.participants = action.payload.data;
      state.isLoading = false;
    },
    clearCurrentPassport: (state) => {
      state.currentPassport = null;
      state.participants = [];
    },
  },
});

export const {
  setLoading,
  setError,
  setPassports,
  setCurrentPassport,
  setParticipants,
  clearCurrentPassport,
} = passportSlice.actions;

export default passportSlice.reducer;
